import React from 'react';
import { Spinner, Typography } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';
import { InlineWarning } from './styles';

export const GeocodingMessage = () => {
  const { t } = useTranslation('common');
  return (
    <InlineWarning data-testid="geocoding-message">
      <Spinner size="sm" aria-label={t('visitFields.address.geocoding')} />
      <Typography variant="caption" tone="secondary">
        {t('visitFields.address.geocoding')}
      </Typography>
    </InlineWarning>
  );
};
